var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44681 11.9914C7.0983 11.9914 6.79931 11.7793 6.67182 11.4772C6.40157 11.2201 6.55231 11.3638 6.48113 11.296C6.21069 11.0383 5.8351 10.6783 5.41426 10.2685C4.5766 9.45263 3.54513 8.42523 2.80918 7.6142C2.49713 7.27031 2.52294 6.73857 2.86682 6.42653C3.2107 6.11448 3.74244 6.14028 4.05449 6.48417C4.7531 7.25405 5.75273 8.25075 6.58753 9.06379L6.60601 9.08179V0.840799C6.60601 0.376438 6.98245 0 7.44681 0C7.91117 0 8.28761 0.376438 8.28761 0.840799V9.15101L11.0646 6.4468C11.3973 6.12284 11.9296 6.12991 12.2536 6.4626C12.5776 6.79528 12.5705 7.3276 12.2378 7.65156L8.09667 11.6841C7.94246 11.8717 7.70861 11.9914 7.44681 11.9914ZM0.857958 16.2841H0V18H0.857958H14.5853H15.4433V16.2841H14.5853H0.857958Z",
    fill: "#001247"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.3ad22e1f.svg";
export { ForwardRef as ReactComponent };